import _ from 'lodash'
import React, { useEffect } from 'react'
import Chart from 'chart.js/auto'
import apiService from 'apiService'

function CardBarTodayStoreSales() {
    const getTodaySalesPerStore = async () => {
        let config = {
            type: 'bar',
            data: {
                labels: [],
                datasets: [
                    {
                        label: 'Αρχικό',
                        backgroundColor: '#ef4444',
                        borderColor: '#ef4444',
                        data: [],
                        fill: false,
                        barThickness: 7
                    },
                    {
                        label: 'Τελικό',
                        fill: false,
                        backgroundColor: '#10b981',
                        borderColor: '#10b981',
                        data: [],
                        barThickness: 7
                    },
                    {
                        label: 'Ποσοστό',
                        fill: false,
                        backgroundColor: 'rgba(2, 132, 199)',
                        borderColor: 'rgba(2, 132, 199)',
                        data: [],
                        barThickness: 0
                    }
                ]
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    }
                },

                maintainAspectRatio: false,
                responsive: true,
                indexAxis: 'y',
                interaction: {
                    mode: 'index'
                }
            }
        }

        const results = await apiService.get(`/stats/today-sales-per-store`)
        if (!results) return
        const labels = results.map(el => el.store_name)
        const startSums = results.map(el => (el.start_sum ? el.start_sum.toFixed(2) : 0))
        const finalSums = results.map(el => (el.final_sum ? el.final_sum.toFixed(2) : 0))
        const percentagesSum = results.map(el => {
            const finalResult = el.final_sum ? el.final_sum : 0
            const startResult = el.start_sum ? el.start_sum : 0
            if (!finalResult || !startResult) return 0
            return ((1 - finalResult / startResult) * 100).toFixed(2) + ''
        })
        config.data.labels = labels
        _.set(config, 'data.datasets[0].data', startSums)
        _.set(config, 'data.datasets[1].data', finalSums)
        _.set(config, 'data.datasets[2].data', percentagesSum)
        let ctx = document.getElementById('bar-chart').getContext('2d')
        window.myBar = new Chart(ctx, config)
    }
    useEffect(() => {
        getTodaySalesPerStore()
    }, [])
    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div className="flex flex-wrap items-center">
                        <div className="relative w-full max-w-full flex-grow flex-1">
                            <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">ΠΩΛΗΣΕΙΣ ΑΝΑ ΚΑΤΑΣΤΗΜΑ</h6>
                            <h2 className="text-blueGray-700 text-xl font-semibold">Ημερήσιες Πωλήσεις</h2>
                        </div>
                    </div>
                </div>
                <div className="p-4 flex-auto">
                    <div className="relative h-600-px">
                        <canvas id="bar-chart"></canvas>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardBarTodayStoreSales
